
import React from "react";
import { numberFormatter } from "../../../utils/formatter";

type Props = {
  detailedData: CustomerDetails;
  isFilterExpanded: boolean
}

const CustomerSelectedMetrices = ({ detailedData, isFilterExpanded }: Props) => {
  const data: {
    label1: string;
    value1: string;
    label2: string;
    value2: string;
  }[] = [{
    label1: "Revenue",
    value1: "$" + numberFormatter(detailedData.revenue, 1),
    label2: "Drops per Month",
    value2: numberFormatter(detailedData.Drops_per_Month, 1)
  },
  {
    label1: "Units (in eaches)",
    value1: numberFormatter(detailedData.volume, 1),
    label2: "Drops per Month",
    value2: numberFormatter(detailedData.Drops_per_Month, 1),
  },
  {
    label1: "Gross Margin",
    value1: "$" + numberFormatter(detailedData.netgrossMargin, 1) + " | " + numberFormatter((detailedData.netgrossMargin / detailedData.revenue) * 100, 1) + "%",
    label2: "Transport cost per drop",
    value2: `$ ${numberFormatter(detailedData.TransCostPerDrop, 0)} ($/drop)`,
  },
  {
    label1: "Contribution Margin",
    value1: "$" + numberFormatter(detailedData.deliveredMargin, 1) + " | " + (numberFormatter((detailedData.deliveredMargin / detailedData.revenue) * 100, 1)) + "%",
    label2: "Contribution Margin per drop",
    value2: `$ ${numberFormatter(detailedData.DMPerDrop, 0)} ($/drop)`,
  }
    ]
  return (
    <div className="w-full flex ">
      <div className="w-full " >
        <div
          className="chart-title text-center border-b pb-[5px] w-full text-black">
          Metrics for Customer: {detailedData.customerDesc} (Sold To:{detailedData.customerId})
        </div>
        <div className="w-full  bg-white border border-lightGrey p-[6px]">
          <table className=" table-container table-stripped-alternate">
            <tbody>
              {data?.map((value, index) => (
                <MetricTableRow key={index}
                  trClass={`${isFilterExpanded ? "h-[4vh]" : "h-[5vh]"}`}
                  label1={value.label1}
                  value1={value.value1}
                  label2={value.label2}
                  value2={value.value2} />))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div >
  );
};

export default CustomerSelectedMetrices;

const MetricTableRow = ({ label1, value1, label2, value2, trClass }: { label1: string, value1: string, label2: string, value2: string, trClass: string }) => {

  return <tr className={trClass}>
    <td
      className="  w-[47.5%]  text-black border-r-[0.1px] border-b-[0.1px] border-[rgb(190, 190, 190)] p-[0.5vw]">
      <div className="flex justify-between text-[1.4vh]">
        <div className=" font-bold">
          {label1}
        </div>
        <div>
          {value1}
        </div>
      </div>
    </td>
    <td
      className=" w-[52.5%] text-black border-r-[0.1px] border-b-[0.1px] border-[rgb(190, 190, 190)]  p-[0.5vw] ">
      <div className="flex justify-between text-[1.4vh]">
        <div className=" font-bold">
          {label2}
        </div>
        <div>
          {value2}
        </div>
      </div>
    </td>
  </tr>
}
